import React, { useId } from 'react';

export default function AudioThumbnail() {
	const gradientId = `paint0_linear_${useId()}`;

	return (
		<div className="flex-center">
			<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 64 64" fill="none">
				<path d="M47.4752 39.251C49.1327 36.4774 50.2323 32.9694 50.4457 29.4983C50.5811 27.2704 50.0846 24.9318 49.0097 22.7326C47.3234 19.2779 44.4267 17.3372 41.6285 15.4622C39.5401 14.0631 37.5666 12.7419 36.1716 10.8546L35.9213 10.5181C35.0966 9.41035 34.1653 8.15485 34.0176 7.10039C33.8699 6.03363 32.9016 5.27459 31.843 5.33613C30.768 5.40998 29.9351 6.30032 29.9351 7.37939V43.9366C28.216 42.8944 26.0989 42.2544 23.7808 42.2544C18.1269 42.2544 13.5234 45.9347 13.5234 50.4602C13.5234 54.9858 18.1269 58.6661 23.7808 58.6661C29.4346 58.6661 34.0381 54.9858 34.0381 50.4602V26.5483C37.1194 27.7259 42.1619 30.7251 43.5487 37.7288C43.2902 38.1104 43.044 38.5207 42.7568 38.8489C42.006 39.6982 42.088 40.9948 42.9414 41.7415C43.7866 42.4964 45.0832 42.4062 45.834 41.5569C46.3838 40.9332 46.872 40.2029 47.3398 39.4397C47.389 39.3823 47.4343 39.3208 47.4752 39.251Z" fill={`url(#${gradientId})`}/>
				<defs>
					<linearGradient id={gradientId} x1="31.9955" y1="58.6661" x2="31.9954" y2="5.33262" gradientUnits="userSpaceOnUse">
						<stop stopColor="#FFFD62"/>
						<stop offset="1" stopColor="#FF6AE6"/>
					</linearGradient>
				</defs>
			</svg>
		</div>
	);
}